module.exports = __webpack_public_path__ + "img/level-next-registration-header.8b7e8750.jpg";